import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { colorIcon } from '@/ui/icons/functions';
import { Icon } from '@/ui/icons/icon';

import { ContentItemForm } from './content-item-form/content-item-form';
import { FixedPanelWithShadowLayer } from '@/components/fixed-panel-with-shadow-layer/fixed-panel-with-shadow-layer';
import { useContentItemSearchParams } from './use-content-item-search-params';
import { ContentItemFormSkeleton } from './content-item-form/content-item-form-skeleton';

export const ContentItemSidebar = () => {
  const { t } = useTranslation('settings', { keyPrefix: 'feedTab' });

  const { isOpened, isEditMode, isInitialized, closeAndResetSidebar } =
    useContentItemSearchParams();

  if (!isOpened) return null;

  return (
    <SidebarWrapper onOutsideClick={closeAndResetSidebar}>
      <Container name="content-item-sidebar-container" direction="column">
        <Header
          name="content-item-sidebar-header"
          alignItems="center"
          justify="space-between"
        >
          <TitleContainer
            name="content-item-sidebar-title"
            alignItems="center"
            gap="24px"
            onClick={closeAndResetSidebar}
          >
            <Icon icon="ArrowLeft2" />
            <TitleValue>
              {t(isEditMode ? 'updateItem' : 'uploadItem')}
            </TitleValue>
          </TitleContainer>
        </Header>
        {!isInitialized ? (
          <ContentItemFormSkeleton />
        ) : (
          <ContentItemForm onCancel={closeAndResetSidebar} />
        )}
      </Container>
    </SidebarWrapper>
  );
};

const SidebarWrapper = styled(FixedPanelWithShadowLayer)`
  right: 0;
  background-color: ${({ theme }) => theme.colors.basics.white};

  ${({ theme }) =>
    theme.animations.slideInHorizontally('right', '800px', '0.3s')};

  @media (min-width: 1600px) {
    min-width: 686px;
    max-width: 1020px;
  }
`;

const Container = styled(Flexbox)`
  box-shadow: ${({ theme }) => theme.shadow.actionsPanel};
  height: 100vh;
  padding: 20px 24px;
  overflow: auto;
`;

const Header = styled(Flexbox)`
  background-color: ${({ theme }) => theme.colors.basics.white};
`;

const TitleContainer = styled(Flexbox)`
  ${({ theme }) => theme.typography.actionsPanel.acrossPanel.inPlatformLocation}
  ${({ theme }) => colorIcon(theme.colors.basics.black)}
  cursor: pointer;
  height: 75px;
`;

const TitleValue = styled('div', forwardRef)`
  ${({ theme }) => theme.mixins.ellipsis}
  max-width: 420px;
`;
